import { Rule } from 'antd/lib/form';
import { Config } from './config';

export const Required = (config?: Config): Rule => ({
  ...config,
  required: true,
});
